import React from "react";
import renderSocialLinks from "../utils/renderSocialLinks.js";
import renderStoreInfo from "../utils/renderStoreInfo";

const Rodape = ({ revenda }) => {
  return (
    <footer className="footer-3 footer-topbar light page-section-pt">
      <div className="container">
        <div className="row top">
          <div className="col-lg-3 col-md-12">
            <img className="img-fluid" id="logo_footer_dark" src="images/logo.png" alt="Logo" />
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="social text-lg-right text-center">
              <ul>{renderSocialLinks(revenda)}</ul>
            </div>
          </div>
        </div>

        <div className="row text-center justify-content-center">
          <div className="col-lg-5 col-md-12">
            <div className="about-content">
              <h2 style={{ color: "#FFF" }}>LW Multimarcas</h2>
              <p style={{ color: "#FFF" }}>
               Na <strong>LW Multimarcas</strong>, você encontra veículos de qualidade, revisados e prontos para rodar, com atendimento de confiança e ótimas opções de financiamento que cabem no seu bolso
              </p>
            </div>
          </div>

          <div className="col-lg-7 col-md-12">
            <ul className="text-sobrenos-info">{renderStoreInfo(revenda)}</ul>
          </div>
        </div>

        <div className="mt-5 text-center">
          <p>
            © 2025 LW Multimarcas | Todos os direitos reservados. <a href="https://intermedioveiculos.com.br/" target="_blank" rel="noopener noreferrer" style={{ color: "#FF0000" }}>Intermédio Veículos Marketing Digital</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Rodape;